import { useQuery } from "@tanstack/react-query";
import { PatientId } from "../../messages";
import { outsourcingAgencyQueryKey } from "./outsourcingAgencyQueryKeys";
import { API } from "../../API";

export function useOutsourcingAgencyQuery(params: {
  patientId: PatientId;
  onRequestOutsourcingAgencyData: API["getOutsourcingAgencyData"];
}) {
  return useQuery({
    queryKey: outsourcingAgencyQueryKey(params.patientId),
    queryFn: () => params.onRequestOutsourcingAgencyData(params.patientId),
    select: (data) => data.agencyData,
  });
}
